import {Component, Input} from '@angular/core';

@Component({
  selector: 'app-form-input-error',
  templateUrl: './form-input-error.component.html',
  styleUrls: ['./form-input-error.component.scss']
})
export class FormInputErrorComponent {
  @Input() color: boolean;
  @Input() cp: boolean;
  @Input() cpProvince: boolean;
  @Input() holidaysRange: boolean;
  @Input() email: boolean;
  @Input() lowerPrice: boolean;
  @Input() passwordRepeat: boolean;
  @Input() required: boolean;
  @Input() show: boolean;
  @Input() validOption: boolean;
  @Input() wrongPhone: boolean;
}
